import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-P",
  "use": "deviceData-P-usage",
  "viewBox": "0 0 8 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 8 11\" id=\"deviceData-P\">\n<g id=\"deviceData-P_web\">\n\t<g id=\"deviceData-P_切图\" transform=\"translate(-28.000000, -137.000000)\">\n\t\t<path id=\"deviceData-P_P\" d=\"M29.6,147.8v-4.3h2.6c1.1,0,2-0.3,2.7-0.9s0.9-1.4,0.9-2.3c0-1-0.3-1.7-0.9-2.3s-1.5-0.9-2.7-0.9l0,0h-4.1v10.7\n\t\t\tH29.6z M32.2,142.4h-2.6v-4.1h2.6c0.7,0,1.3,0.2,1.6,0.6s0.5,0.9,0.5,1.5s-0.2,1.1-0.5,1.5S33,142.4,32.2,142.4L32.2,142.4z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-P.svg
// module id = tzqx
// module chunks = 268